<header [class.header-fixed]="headerFixed" (click)="onClickHeader()" (outsideClick)="handleOutsideClick()"
  appOutSideClick>
  <div class="container">
    <div class="header-main">
      <div class="header-left">
        <div class="header-toggle-button">
          <button type="button" class="toggle-btn" (click)="onSideNavToggling()"
            aria-label="Toggle side navigation menu">
            <i class="fa-solid fa-bars" aria-hidden="true"></i>
          </button>
        </div>
        <div class="logo">
          <img (click)="onNavigate()" routerLink="/" src="{{
              shopInfo?.navLogo ?? 'assets/images/brand/logo/trustlogo.png'
            }}" alt="Quick Pharma - Home" />

          <div class="address" *ngIf="selectedAddress || (addresses && addresses.length)">
            <button (click)="openDialog()" aria-label="Change delivery address">
              <h2>
                <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
              </h2>
              <p>
                <span class="deliver">Deliver to</span>
                <span class="area-address">
                  {{
                  selectedAddress
                  ? selectedAddress?.area?.name
                  : addresses[0]?.area?.name
                  ? addresses[0]?.area?.name
                  : "N/A"
                  }},
                  {{
                  selectedAddress
                  ? selectedAddress?.division?.name
                  : addresses[0]?.division?.name
                  ? addresses[0]?.division?.name
                  : "N/A"
                  }}</span>
              </p>
            </button>
          </div>
        </div>
      </div>

      <div class="header-middle">
        <div class="header-middle-top-main" (click)="onClickSearchArea($event)">
          <div class="header-middle-top">
            <div class="search-bar">
              <form #searchForm="ngForm">
                <input #searchInput id="searchInput" class="tw" type="text" placeholder="|"
                  (focus)="handleFocus($event)" (blur)="handleBlur()" name="searchTerm" autocomplete="off"
                  (keyup)="onKeyPress($event)" ngModel required (keydown.enter)="onSearchNavigate()" />
              </form>

              <!--              <form #searchForm="ngForm">-->
              <!--                <input-->
              <!--                  #searchInput-->
              <!--                  id="searchInput"-->
              <!--                  class="tw"-->
              <!--                  type="text"-->
              <!--                  placeholder="|"-->
              <!--                  (focus)="handleFocus($event)"-->
              <!--                  (blur)="handleBlur()"-->
              <!--                  name="searchTerm"-->
              <!--                  autocomplete="off"-->
              <!--                  ngModel-->
              <!--                  required-->
              <!--                  (keydown.enter)="onSearchNavigate()"-->
              <!--                />-->
              <!--              </form>-->
            </div>
            <button type="button" (click)="onSearchNavigate()" class="search-icon" aria-label="Search">
              <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            </button>
          </div>

          <ul class="auto-complete-box" [ngClass]="
              !searchProducts?.length && this.selectArray?.length && isFocused
                ? 'active'
                : ''
            ">
            <li *ngFor="let data of selectArray; let i = index" class="search-history">
              <button type="button" (click)="onSelectArray(data?.name, searchInput, i)">
                {{ data?.name | titlecase }}
              </button>
              <button type="button" class="delete-btn" (click)="onDeleteStoredSearch($event, data?.name)">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </li>
          </ul>

          <ul class="auto-complete-box" [ngClass]="searchProducts?.length == 0 && isOpen ? 'active' : ''">
            <li class="message">
              <p>
                Sorry! We couldn't find your Medicine or Product. Do you want to
                make a request? Please
                <button (click)="openDialogRequestMedicine()" class="requestMedicine">
                  Click here
                </button>
              </p>
            </li>
          </ul>
          <ul id="auto-suggestion" class="auto-complete-box"
            [ngClass]="searchProducts?.length > 0 && isOpen ? 'active' : ''">
            <li class="list-view" *ngFor="let data of searchProducts" (click)="onSelectItem(data)">
              <div class="search-result-left">
                <div class="result-product-img">
                  <h5 class="discount" *ngIf="data?.prices[0]?.discountAmount">
                    <span class="dis-span">-{{ data?.prices[0]?.discountAmount
                      }}{{
                      data?.prices[0]?.discountType === 1 ? "%" : "৳"
                      }}</span>
                  </h5>
                  <img class="img-thumb" [src]="
                      data?.images && data?.images?.length
                        ? data?.images[0]
                        : '/assets/images/placeholder/test.png'
                    " [alt]="data?.name" />
                </div>
                <div class="desc">
                  <h3>
                    {{ data?.name }}
                    <span>
                      <sup>{{ data?.milligram }} </sup></span>
                    <span> {{ data?.type?.name }}</span>
                  </h3>
                  <h3 class="generic">{{ data?.generic?.name }}</h3>
                  <h3 class="generic">{{ data?.brand?.name }}</h3>
                </div>
              </div>
              <div class="price">
                <h5 class="discount" *ngIf="data?.prices[0]?.discountAmount">
                  <del>৳ {{ data?.prices[0]?.salePrice }}</del>
                </h5>
                <h5>
                  <span>৳ </span>{{ data?.prices[0] | price: "salePrice" }}
                </h5>
              </div>
            </li>
          </ul>
        </div>

        <div class="header-middle-bottom nav">
          <ul>
            <li>
              <a href="/" routerLink="/">
                <i class="fa-solid fa-house"></i>
                <span>Home</span></a>
            </li>
            <li>
              <a href="/product-list" routerLink="/product-list" (click)="onProductsClick()">
                <span><i class="fa-solid fa-bag-shopping"></i></span>
                <span>Products</span></a>
            </li>
            <li>
              <a href="/blogs" routerLink="/blogs">
                <i class="fa fa-edit"></i>
                <span>Blog</span></a>
            </li>
            <li>
              <a href="/coming-soon" routerLink="/coming-soon">
                <i class="fa-solid fa-user-doctor"></i>
                <span>Online Doctor</span></a>
            </li>
            <li>
              <a href="/coming-soon" routerLink="/coming-soon">
                <i class="fa-solid fa-person-dots-from-line"></i>
                <span>Online Diagnosis</span></a>
            </li>
          </ul>
        </div>
      </div>

      <div class="header-right">
        <div class="header-right-top">
          <ul>
            <li>
              <a class="profile" href="/login" routerLink="/login">
                <img [src]="
                    user?.profileImg ?? '/assets/images/jpg/dummy-image.jpg'
                  " alt="user" />
                <h3>
                  {{ userService.getUserStatus() ? user?.name : "Login" }}
                </h3>
              </a>
            </li>
            <li class="hotline-number" *ngIf="shopInfo?.phones && shopInfo?.phones[0]?.value">
              <a href="tel:{{ shopInfo?.phones[0]?.value }}" class="hotline-link">
                <i class="fa-solid fa-phone"></i>
                <span>{{ shopInfo?.phones[0]?.value }}</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="header-right-bottom">
          <div (click)="getOrdersByUser(); onGoProfile()">
            <button type="button" class="order-traking">
              <span>Order Tracking</span>
            </button>
          </div>

          <button type="button" (click)="onShowUploadPrescription()" cart-box class="prescription-upload">
            <i class="fa fa-hospital-o pr-2"></i>
            <span>Upload Prescription</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="cart-fixed-box" *ngIf="carts?.length" [class.cart-box-animate]="cartAnimate">
  <div>
    <img src="../../../../assets/images/png/carticon.png" alt="Shopping cart" />
  </div>
  <div class="cart-box" (click)="onCartSideToggling()">
    <div class="cart-box-top">
      <span>{{ carts?.length | numMinDigit }} Items</span>
      <i class="fa-solid fa-basket-shopping"></i>
    </div>
    <div class="cart-price">
      <span>৳{{ cartSubTotal | number: "2.2" }}</span>
    </div>
  </div>
</div>

<div class="icon-bar" id="icon-bar">
  <div [ngClass]="toggleStyle ? 'show' : 'hide'" id="socialicon">
    <a *ngIf="shopInfoByFb?.value" [href]="shopInfoByFb?.value" target="_new" rel="noopener" class="facebook"
      aria-label="Visit our Facebook page">
      <i class="fa-brands fa-facebook-f" aria-hidden="true"></i>
    </a>
    <a href="https://api.whatsapp.com/send?phone=+8801885222088&amp;text=Hello, Welcome to Quick Pharma" target="_new"
      rel="noopener" class="twitter" aria-label="Chat with us on WhatsApp">
      <i class="fa-brands fa-whatsapp" aria-hidden="true"></i>
    </a>
  </div>
  <a href="tel:+8801885222088" data-title="+8801885222088" class="google phone"
    aria-label="Call us at +8801885222088"><i class="fa-solid fa-phone" aria-hidden="true"></i></a>
  <button type="button" (click)="toggle()" id="toggle" class="google" aria-label="Toggle social media links">
    <i class="fa-regular fa-comment" aria-hidden="true"></i>
  </button>
</div>
<!-- Social End-->

<div class="bottom-nav" *ngIf="isBottomNav">
  <ul>
    <li>
      <a href="/" routerLink="/">
        <span><i class="fa fa-home"></i></span>
        <h4>Home</h4>
      </a>
    </li>
    <li>
      <a href="/categories" (click)="onshowHideSideNav()" routerLink="/categories">
        <span><i class="fas fa-list"></i></span>
        <h4>category</h4>
      </a>
    </li>
    <li>
      <a href="/cart" routerLink="/cart" (click)="onCartSideToggling(); $event.preventDefault()">
        <span><i class="fas fa-shopping-basket"></i></span>
        <h4>carts</h4>
        <small [ngClass]="{ 'res-cart-box-animate': cartAnimate == true }">{{
          carts?.length | numMinDigit
          }}</small>
      </a>
    </li>
    <li>
      <a href="/account/favorite" routerLink="/account/favorite" (click)="_accountService.accountShow.next(true)">
        <span><i class="fas fa-heart"></i></span>
        <h4>wishlist</h4>
        <small>{{ wishLists?.length | numMinDigit }}</small>
      </a>
    </li>
    <li>
      <a [href]="userService.getUserStatus() ? '/account/my-account' : '/login'" [routerLink]="
          userService.getUserStatus() ? '/account/my-account' : '/login'
        " (click)="onGoAccount()">
        <span><i class="fas fa-user"></i></span>
        <h4>{{ userService.getUserStatus() ? user?.name : "Login" }}</h4>
      </a>
    </li>
  </ul>
</div>

<app-side-nav #side_nav [selectedAddress]="selectedAddress" [address]="addresses"
  (customEvent)="onShowUploadPrescription()"></app-side-nav>

<app-cart-slide #cart_slide [carts]="carts"></app-cart-slide>